import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const SuccessMessages = ({ message }: SuccessMessagesProps) => {
  const [hasTimer, setHasTimer] = useState(false);
  const [isFadeOut, setIsFadeOut] = useState(false);

  useEffect(() => {
    const timer = document.querySelector('.c-banner-timer');
    setHasTimer(timer !== null);

    if (message) setTimeout(() => setIsFadeOut(true), 4000);
  }, [isFadeOut, message]);

  useEffect(() => {
    setIsFadeOut(false);
  }, [message]);

  if (message) {
    const containsPromoCodeMessage = message.includes('promo code');

    return (
      <div className={`
        c-banner c-banner--success-message
        ${hasTimer ? '' : 'c-banner--success-message--bottom'}
        ${isFadeOut ? 'c-banner--success-message--fade-out' : ''}
        ${containsPromoCodeMessage ? 'c-banner--success-message--promo-code' : ''}
      `}
      >
        <div className="o-section  o-section--padding-bottom-zero">
          <div className="o-container">
            <div className="o-grid">
              <div className="o-col  o-col--offset-1@medium  o-col--padding-bottom-zero">
                <div className="o-col__inner">
                  <div className="c-banner__content">{message}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

const SuccessMessagesPropTypes = {
  message: PropTypes.string.isRequired,
};

SuccessMessages.propTypes = SuccessMessagesPropTypes;

type SuccessMessagesProps = PropTypes.InferProps<typeof SuccessMessagesPropTypes>;

export default SuccessMessages;
